// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1cxDW","visuallyhidden":"_2PBfG","hide-text":"_1hKHG","center":"_1dl2J","noprint":"_3gMyA","headline":"_11zKy _1o64I"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-headline/styles/feature.scss
 ** module id = 211
 ** module chunks = 2
 **/